module.exports = __webpack_public_path__ + "img/arrow_right.35f0c3f9.png";